import { currentUiLocale } from "../i18n/index.js";

/**
 * The body of every `POST /sessions/:id/reconnect`, from every surface.
 *
 * It carries the interface language the browser shows NOW. When the call boots
 * a sandbox, that is the language the agent is told to write in (on a project
 * whose `.loom.yml` sets none) — so a user who switched the interface language
 * and came back to a session opened in the other one gets the new language at
 * the next boot, instead of the one the session remembered from its create. A
 * sandbox that is still running keeps the directive it booted with.
 *
 * A module of its own rather than an export of `sessionBeacon.ts`, which
 * several suites replace wholesale with a two-function mock: a surface that
 * reached this through that mock would throw on every wake.
 */
export const reconnectBody = (): string =>
  JSON.stringify({ uiLocale: currentUiLocale() });
